import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import { LocationLanguageContext } from '../contexts/LocationLanguageContext';
import { FooterColumnL, FooterColumnR, FooterMenu, FooterRoot, FooterRow, LinkTypography, MarkdownText } from '../styles/Footer';
import { FooterQueryProps, LocationLanguageContextType } from '../typings';
import { Languages } from '../utils/getAllSupportedLanguages';
import { getMarkdownValue } from '../utils/getMarkdownValue';
import { selectLocalizedData } from '../utils/selectLocalizedData';
import { LanguageSwitcher } from './LanguageSwitcher';

export const PureFooter: React.FC<FooterQueryProps> = ({ footer }) => {
  if (footer) {
    return (
      <FooterRoot>
        <Container maxWidth='xl'>
          <FooterRow>
            <FooterColumnL>
              <FooterMenu>
                <LinkTypography>
                  <a href={footer.privacyLink}>{footer.privacy}</a>
                </LinkTypography>
                <LinkTypography>
                  <a href={footer.cookieLink}>{footer.cookie}</a>
                </LinkTypography>
                <LinkTypography>
                  <a href={footer.termsLink}>{footer.terms}</a>
                </LinkTypography>
                <LinkTypography>
                  <a href={footer.nLSupportLink}>{footer.support}</a>
                </LinkTypography>
                <LinkTypography>
                  <a href={footer.contactLink}>{footer.contact}</a>
                </LinkTypography>
              </FooterMenu>
            </FooterColumnL>
            <FooterColumnR>
              <LanguageSwitcher />
            </FooterColumnR>
          </FooterRow>
          <Typography component='div' style={{ marginLeft: '1em' }}>
            <MarkdownText>
              <ReactMarkdown>{getMarkdownValue(footer.copyright)}</ReactMarkdown>
            </MarkdownText>
          </Typography>
        </Container>
      </FooterRoot>
    );
  }
  return null;
};

export const Footer: React.FC = () => {
  const data = useStaticQuery(
    graphql`
      query FooterQuery {
        allStrapiFooter {
          nodes {
            cookie
            privacy
            support
            terms
            privacyLink
            cookieLink
            termsLink
            nLSupportLink
            copyright {
              data {
                copyright
              }
            }
            contact
            contactLink
            locale
            localizations {
              cookie
              privacy
              support
              terms
              privacyLink
              cookieLink
              termsLink
              nLSupportLink
              copyright
              contact
              contactLink
              locale
            }
          }
        }
      }
    `
  );

  const locationLanguage = React.useContext<LocationLanguageContextType | null>(LocationLanguageContext);
  const language: string = locationLanguage?.language ?? Languages.English;
  const footerContent = selectLocalizedData(data.allStrapiFooter.nodes[0], language);

  return <PureFooter footer={footerContent} />;
};

export default Footer;
